module.exports = __webpack_public_path__ + "static/media/parts_box.cf8c8f17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/parts_box.png
// module id = 2435
// module chunks = 0